import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { authActions } from "../../store/auth";
import { Link } from "react-router-dom";

// import NotFound from "../404";

const LeadAmazeBonus = () => {
  const dispatch = useDispatch();
  //   const access = useSelector((state) => state.auth.access);

  useEffect(() => {
    dispatch(authActions.setLoaderStatus({ status: false }));
  });

  return (
    <>
      <section className="mid_wrap">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-4 pb-2">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                LeadAmaze
              </li>
            </ol>
          </nav>
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="bx_a">
                <div className="emptyDiv">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                    alt="img"
                    className="mt-4"
                  />
                  <br />
                  <h4 className="mb-4">LeadAmaze Login Access</h4>
                  <h6><strong className="text-secondary">Email : </strong> (**Your Paypal Email**)</h6>
                  <h6><strong className="text-secondary">Password : </strong> ur94ur93f</h6>
                  <a
                    className="btn mt-3"
                    href="https://leadamaze.vidamaze.io/login"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Click here to access Leadamaze
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LeadAmazeBonus;
